import { Route } from 'config/routes';
import { call, put, select } from 'redux-saga/effects';
import { managedOfficeSelector } from 'store/state/domainData/selectors';
import { navigateTo } from 'store/state/router/actions';

function* agentPageWorker() {
  const managedOfficeId: string | null = yield select(managedOfficeSelector);

  if (!managedOfficeId) {
    yield put(navigateTo(Route.AgentConsoleHomePage, {}, { replace: true }));
  }
}

export function* createOfficeAgentPageHandler() {
  yield call(agentPageWorker);
}
